import { SVGIconComponent } from './types';

export const ProjectTypeHubs: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M9 0C4.02 0 0 4.02 0 9s4.02 9 9 9 9-4.02 9-9-4.02-9-9-9m1.4 17.06V13.9h1.06c.44 0 .56-.24.24-.56l-2.12-2.1a.82.82 0 0 0-1.16 0l-2.12 2.1c-.32.32-.22.56.24.56h.98v3.14a8.18 8.18 0 0 1-6.56-6.56H4.1v.98c0 .46.24.56.56.24l2.1-2.121c.32-.32.3-.84-.02-1.16l-2.1-2.12c-.32-.32-.56-.22-.56.24V7.6H.94A8.22 8.22 0 0 1 7.52.94v3.14h-.98c-.46 0-.56.24-.24.56l2.12 2.1c.32.32.84.3 1.16-.02l2.12-2.1c.321-.32.221-.56-.24-.56H10.4V.94c3.4.58 6.08 3.26 6.66 6.66H13.9V6.54c0-.44-.24-.56-.56-.24l-2.1 2.121a.82.82 0 0 0 0 1.16l2.1 2.12c.32.32.56.22.56-.24v-.979h3.14a8.195 8.195 0 0 1-6.64 6.58"
    />
  </svg>
);
